var exports = {
  "iE": "xaf9ae18d--ed1903--wrapper",
  "kL": "xaf9ae18d--ed1903--container",
  "my": "xaf9ae18d--ed1903--indent--small",
  "oA": "xaf9ae18d--ed1903--indent--medium",
  "Uj": "xaf9ae18d--ed1903--indent--large",
  "pF": "xaf9ae18d--ed1903--indent--extra-large",
  "H4": "xaf9ae18d--ed1903--placement--left",
  "Y$": "xaf9ae18d--ed1903--placement--right",
  "RG": "xaf9ae18d--ed1903--placement--top",
  "s4": "xaf9ae18d--ed1903--placement--top-right",
  "n3": "xaf9ae18d--ed1903--placement--top-left",
  "FG": "xaf9ae18d--ed1903--placement--bottom",
  "aD": "xaf9ae18d--ed1903--placement--bottom-right",
  "nD": "xaf9ae18d--ed1903--placement--bottom-left",
  "u1": "xaf9ae18d--ed1903--spinner",
  "mx": "xaf9ae18d--ed1903--image-block",
  "Pf": "xaf9ae18d--ed1903--label",
  "Lq": "xaf9ae18d--ed1903--loading",
  "Sl": "xaf9ae18d--ed1903--image",
  "iX": "xaf9ae18d--ed1903--content-block",
  "DD": "xaf9ae18d--ed1903--title",
  "qT": "xaf9ae18d--ed1903--features",
  "yp": "xaf9ae18d--ed1903--features-item",
};

module.exports = exports;
